import { Box, Container, Grid, Typography, Button, Stack } from "@mui/material";


export default function Header({ config = {} }) {
  const accent = config?.GradientColor || "#2563eb";
  const titleColor = config?.TitleColor || "#0f172a";
  const subtitleColor = config?.SubTitleColor || "#475569";
  const descriptionColor = config?.DescriptionColor || "#64748b";

  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        minHeight: { xs: "auto", md: "76vh" },
        display: "flex",
        alignItems: "center",
        background: `linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)`,
        py: { xs: 8, md: 10 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: 520,
          height: 520,
          borderRadius: "50%",
          background: accent,
          opacity: 0.08,
          filter: "blur(10px)",
          top: -260,
          right: -160,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: 260,
          height: 260,
          borderRadius: "50%",
          background: accent,
          opacity: 0.06,
          bottom: -130,
          left: -80,
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ maxWidth: 650 }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  px: 1.5,
                  py: 0.75,
                  mb: 3,
                  borderRadius: 99,
                  bgcolor: `${accent}12`,
                  color: accent,
                  fontSize: 13,
                  fontWeight: 700,
                  letterSpacing: ".04em",
                  textTransform: "uppercase",
                }}
              >
                {config?.Badge || "Conheça nossa empresa"}
              </Box>

              <Typography
                component="h1"
                sx={{
                  color: titleColor,
                  fontWeight: 800,
                  lineHeight: 1.05,
                  letterSpacing: "-.04em",
                  fontSize: { xs: "2.7rem", sm: "3.5rem", md: "4.4rem" },
                  mb: 2,
                }}
              >
                {config?.Title || ""}
              </Typography>

              <Typography
                sx={{
                  color: subtitleColor,
                  fontSize: { xs: "1.15rem", md: "1.35rem" },
                  lineHeight: 1.5,
                  fontWeight: 600,
                  maxWidth: 580,
                  mb: 2.5,
                }}
              >
                {config?.SubTitle || ""}
              </Typography>

              <Typography
                sx={{
                  color: descriptionColor,
                  lineHeight: 1.8,
                  fontSize: "1rem",
                  maxWidth: 580,
                }}
              >
                {config?.Description || ""}
              </Typography>

              {config?.LinkSite && (
                <Stack direction="row" sx={{ mt: 4 }}>
                  <Button
                    variant="contained"
                    size="large"
                    href={config.LinkSite}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      px: 3.5,
                      py: 1.5,
                      borderRadius: 2.5,
                      bgcolor: config?.ButtonColor || accent,
                      color: config?.ButtonLabelColor || "#fff",
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: "1rem",
                      boxShadow: `0 14px 30px ${accent}30`,
                      "&:hover": {
                        bgcolor: config?.ButtonColor || accent,
                        transform: "translateY(-2px)",
                        boxShadow: `0 18px 34px ${accent}3d`,
                      },
                      transition: "all .2s ease",
                    }}
                  >
                    {config?.ButtonLabel || "Saiba mais"}
                  </Button>
                </Stack>
              )}
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            {config?.Image && (
              <Box
                sx={{
                  position: "relative",
                  maxWidth: 620,
                  mx: "auto",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: { xs: "6% 3%", md: "5% -3% -3% 5%" },
                    borderRadius: { xs: 4, md: 6 },
                    background: `linear-gradient(135deg, ${accent}20, ${accent}06)`,
                    transform: "rotate(3deg)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={config.Image}
                  alt={config?.Title || "Imagem"}
                  sx={{
                    position: "relative",
                    width: "100%",
                    maxHeight: { xs: 420, md: 540 },
                    objectFit: "contain",
                    display: "block",
                    borderRadius: { xs: 4, md: 6 },
                    boxShadow: "0 30px 70px rgba(15, 23, 42, .14)",
                  }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
